import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";

import css from "../assets/css.png";

import git from "../assets/git.png";

import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import mu5 from "../assets/mu5.png";
import node from "../assets/node.png";

import react from "../assets/react.png";
import redux from "../assets/redux.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import logo1 from "../assets/logo1.png";

import adidas from "../assets/adidas.png";
import amazon from "../assets/amazon.png";
import asus from "../assets/asus.png";

import nb from "../assets/nb.png";

import spotify from "../assets/spotify.png";

import java from "../assets/java.png";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

export default {
  email,
  mobile,
  api,

  css,

  git,

  html,
  java,
  javascript,
  mu5,
  node,

  react,
  redux,

  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  logo1,
  adidas,
  amazon,
  asus,

  nb,

  spotify,
};
